"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.socialDribbble = void 0;
var socialDribbble = {
  "viewBox": "0 0 512 512",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "g",
      "attribs": {},
      "children": [{
        "name": "g",
        "attribs": {},
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M256,64C150,64,64,150,64,256c0,106.1,86,192,192,192s192-85.9,192-192C448,150,362,64,256,64z M256,415.5\r\n\t\t\tc-88.1,0-159.5-71.4-159.5-159.5c0-88.1,71.4-159.5,159.5-159.5c88.1,0,159.5,71.4,159.5,159.5C415.5,344.1,344.1,415.5,256,415.5\r\n\t\t\tz"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M256,64C150,64,64,150,64,256c0,106.1,86,192,192,192s192-85.9,192-192C448,150,362,64,256,64z M256,415.5\r\n\t\t\tc-88.1,0-159.5-71.4-159.5-159.5c0-88.1,71.4-159.5,159.5-159.5c88.1,0,159.5,71.4,159.5,159.5C415.5,344.1,344.1,415.5,256,415.5\r\n\t\t\tz"
            },
            "children": []
          }]
        }]
      }]
    }, {
      "name": "g",
      "attribs": {},
      "children": [{
        "name": "g",
        "attribs": {},
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M306.3,246.7c23.4-2.2,50.9-2.9,77.2-2.4c-2.3-25.4-12-48.7-27-67.6c-16.5,14.9-38,28.1-63.3,39\r\n\t\t\tC297.8,225.7,302.1,236.1,306.3,246.7z"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M306.3,246.7c23.4-2.2,50.9-2.9,77.2-2.4c-2.3-25.4-12-48.7-27-67.6c-16.5,14.9-38,28.1-63.3,39\r\n\t\t\tC297.8,225.7,302.1,236.1,306.3,246.7z"
            },
            "children": []
          }]
        }, {
          "name": "path",
          "attribs": {
            "d": "M335.4,155.6C313.6,138.3,286,128,256,128c-5.1,0-10.2,0.3-15.2,0.9c13.8,17.7,26.7,37.6,38.6,59.5\r\n\t\t\tC301.1,179.2,320,168.1,335.4,155.6z"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M335.4,155.6C313.6,138.3,286,128,256,128c-5.1,0-10.2,0.3-15.2,0.9c13.8,17.7,26.7,37.6,38.6,59.5\r\n\t\t\tC301.1,179.2,320,168.1,335.4,155.6z"
            },
            "children": []
          }]
        }, {
          "name": "path",
          "attribs": {
            "d": "M205.9,138.2c-34.1,14.5-60.7,43.4-72,79.1c41.1-0.7,79.6-7,113.4-17.3C234.7,177,220.7,156.3,205.9,138.2z"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M205.9,138.2c-34.1,14.5-60.7,43.4-72,79.1c41.1-0.7,79.6-7,113.4-17.3C234.7,177,220.7,156.3,205.9,138.2z"
            },
            "children": []
          }]
        }, {
          "name": "path",
          "attribs": {
            "d": "M383,272.2c-22.3-0.6-46-0.2-66.9,1.5c4.1,12.3,8.1,24.9,11.5,37.9c3.8,14.6,7,29.1,9.6,43.4\r\n\t\t\tC361.8,334.7,378.8,305.4,383,272.2z"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M383,272.2c-22.3-0.6-46-0.2-66.9,1.5c4.1,12.3,8.1,24.9,11.5,37.9c3.8,14.6,7,29.1,9.6,43.4\r\n\t\t\tC361.8,334.7,378.8,305.4,383,272.2z"
            },
            "children": []
          }]
        }, {
          "name": "path",
          "attribs": {
            "d": "M258,256.1c3.9-1.6,8.8-3,14.3-4.3c-3.4-8.3-7.1-16.4-10.8-24.3c-39.1,12.6-84.6,20.3-133.3,21.3\r\n\t\t\tc-0.1,2.4-0.2,4.8-0.2,7.3c0,29.1,9.7,55.9,26,77.4C178.9,301,214.9,274.2,258,256.1z"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M258,256.1c3.9-1.6,8.8-3,14.3-4.3c-3.4-8.3-7.1-16.4-10.8-24.3c-39.1,12.6-84.6,20.3-133.3,21.3\r\n\t\t\tc-0.1,2.4-0.2,4.8-0.2,7.3c0,29.1,9.7,55.9,26,77.4C178.9,301,214.9,274.2,258,256.1z"
            },
            "children": []
          }]
        }, {
          "name": "path",
          "attribs": {
            "d": "M282.6,278.2c-6.9,1.5-12.9,3.2-17.4,5.3c-37.1,16.8-68.3,41.6-90.4,71.5c22.1,18.2,50.4,29,81.2,29\r\n\t\t\tc18.5,0,36-3.9,51.8-10.9c-2.7-15.1-6-30.3-10-45.7C293.4,310.5,288.2,294,282.6,278.2z"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M282.6,278.2c-6.9,1.5-12.9,3.2-17.4,5.3c-37.1,16.8-68.3,41.6-90.4,71.5c22.1,18.2,50.4,29,81.2,29\r\n\t\t\tc18.5,0,36-3.9,51.8-10.9c-2.7-15.1-6-30.3-10-45.7C293.4,310.5,288.2,294,282.6,278.2z"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.socialDribbble = socialDribbble;